import { sel } from "../../academy/selectors";
import { TutorialDefinition } from "../types";

/**
 * Academy lesson: cancel or recover an upload. Started from the lesson page in
 * a new tab; never auto-started. The tour only points at controls: it never
 * uploads, cancels, or deletes anything.
 */
const tour: TutorialDefinition = {
  id: "cancel-or-recover-an-upload",
  version: "1.0.0",
  releasedAt: "2026-10-29T00:00:00.000Z",
  category: "onboarding",
  title: "Cancel or recover",
  description: "Where to look when an upload seems stuck, and how to start again.",
  triggerRoute: /^\/cases(\/.*)?$/,
  startRoute: "/cases",
  lessonId: "cancel-or-recover-an-upload",
  autoStart: false,
  steps: [
    {
      target: sel("casesNav"),
      waitFor: sel("casesNav"),
      title: "Check Cases first",
      content:
        "If an upload bar stopped moving, reload the page and look here to see whether the case exists. A spinner on a case means it is still processing.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("newCaseDropdown"),
      waitFor: sel("newCaseDropdown"),
      title: "Start again",
      content:
        "Click New Case, then Upload Files. In the upload window, Previous Uploads reuses a file that already reached the server, so you do not send it twice.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("trashNav"),
      waitFor: sel("trashNav"),
      title: "Cancelled cases land in Trash",
      content:
        "While files are still uploading, the progress toast at the bottom of the screen has a Cancel upload button. Cancelling deletes the sent files, stops transcription, and moves the case here.",
      disableBeacon: true,
      placement: "right",
    },
    {
      target: sel("caseListItem"),
      waitFor: sel("caseListItem"),
      title: "Once processing starts",
      content:
        "A processing case that says you can safely leave the page is fine. There is no cancel button after processing starts, so let it finish and delete the case if you do not need it.",
      disableBeacon: true,
      placement: "right",
    },
  ],
};

export default tour;
